import React from "react";

import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../Shared/Styles/ContainerStyles";
import Paper from "@material-ui/core/Paper";
import NewTable from "../../Shared/Components/Table/NewTable";
import TableStatusIndicator from "../../Shared/Components/Table/TableStatusIndicator";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import ConfirmAlert from "../../Shared/Components/Confirm/ConfirmAlert";
import MenuItem from "@material-ui/core/MenuItem";

import ConfirmationRequestDetail from "./ConfirmationRequestDetail";
import {
  dateCellDataGetter,
  getCountURLFromFilters,
  getInfiniteURLFromFilters,
  nestedCellDataGetter,
  nestedSort,
} from "../../Shared/Components/Table/TableUtilities";

import api from "../../Shared/Functions/APIHelpers";

const initialState = {
  detailDialogOpen: false,
  confirmationDetailDialogOpen: false,
  confirmationDetail: {},

  //FOR TABLE
  tableData: [],
  recordCount: 0,
  dataURL: "confirmation-mewa",
  staticFilterURL: "confirmation-mewa-static-filter",
  staticFilters: ["employer__mewa__name","status"],
  staticFilterValues: [],
  sortBy: "",
  sortDirection: "ASC",
  countURL: "confirmation-mewa-count",
  initialCount: "--",
  currentCount: "--",
  activeFilters: [],
  fetching: false,
  initialLoadDone: true,
  closeMenu: null,

  /*state for confirm alert */
  confirmAlertTitle: "",
  confirmAlertText: "",
  confirmAlertOpen: false,
  doFunc: null,
  doNotFunc: null,
};

class ContactContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  reset() {
    this.setState(initialState);
  }

  componentDidMount() {
    this.handleInitialData(true);
  }

  handleInitialData = (isInitial) => {
    this.setState({ initialLoadDone: false, fetching: true }, () => {
      this.getStaticFilterValues().then((values) => {
        this.setState({ staticFilterValues: values }, () => {
          this.getTableCount().then((count) => {
            this.getTableData(0, 10)
              .then((r) => {
                this.setState({
                  tableData: r,
                  recordCount: count["record_count"],
                  fetching: false,
                  initialLoadDone: true,
                });
                //if this is the first time the page is mounted, set record count as initial table amount
                //else set the current filtered count
                if (isInitial)
                  this.setState({
                    initialCount: count["record_count"],
                    currentCount: count["record_count"],
                  });
                else this.setState({ currentCount: count["record_count"] });
              })
              .catch((err) => {
                if (err === 403) {
                  this.props.history.push("/mewa-admin/auth?error=5");
                }
                if (err === 400) {
                  this.props.enqueueSnackbar(
                    "Something went wrong rendering medicare",
                    {
                      variant: "error",
                    }
                  );
                }
              });
          });
        });
      });
    });
  };

  loadMoreRows = ({ startIndex, stopIndex }) => {
    if (this.state.fetching) return;
    this.setState({ fetching: true }, () => {
      return new Promise((resolve, reject) => {
        this.getTableData(startIndex, stopIndex)
          .then((r) => {
            var currentData = this.state.tableData;
            var newData = [...currentData, ...r];
            this.setState({ tableData: newData, fetching: false }, () => {
              resolve(newData);
            });
          })
          .catch((err) => {
            if (err === 403) {
              this.props.history.push("/mewa-admin/auth?error=5");
            }
            if (err === 400) {
              this.props.enqueueSnackbar(
                "Something went wrong rendering Contacts",
                {
                  variant: "error",
                }
              );
            }
          });
      });
    });
  };

  getTableCount = () => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getTableCount(
          getCountURLFromFilters(this.state.activeFilters, this.state.countURL)
        )
      );
    });
  };

  getTableData = (startIndex, stopIndex) => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getTableData(
          getInfiniteURLFromFilters(
            this.state.activeFilters,
            this.state.dataURL,
            startIndex,
            stopIndex,
            this.state.sortBy,
            this.state.sortDirection,
            ""
          )
        )
      );
    });
  };

  getStaticFilterValues = () => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getStaticFilterValues(
          this.state.staticFilterURL,
          JSON.stringify({ filters: this.state.staticFilters })
        )
      );
    });
  };

  setActiveFilters = (filters) => {
    this.setState({ activeFilters: filters }, () => {
      this.handleInitialData();
    });
  };

  sortTable = (sortBy, sortDirection, col) => {
    this.setState({ sortBy: sortBy, sortDirection: sortDirection }, () => {
      this.handleInitialData();
    });
  };

  getActionMenuItems = (selectedItem, closeMenu) => {
    const { classes } = this.props;
    return (
      <div>
        <MenuItem
          onClick={() => {
            this.handleTrackConfirmation(selectedItem, closeMenu);
          }}
        >
          <LocalShippingIcon className={classes.leftIcon} />
          Track Requests
        </MenuItem>
      </div>
    );
  };

  handleTrackConfirmation = (selectedItem, closeMenu) => {
    this.setState({confirmationDetail: selectedItem, confirmationDetailDialogOpen: true})
    closeMenu()
  };


  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <ConfirmAlert
          isOpen={this.state.confirmAlertOpen}
          isNo={this.state.doNotFunc}
          isYes={this.state.doFunc}
          AlertTitle={this.state.confirmAlertTitle}
          AlertText={this.state.confirmAlertText}
        />
        <ConfirmationRequestDetail
          Open={this.state.confirmationDetailDialogOpen}
          Close={()=>{this.setState({confirmationDetailDialogOpen: false, confirmationDetail:{}})}}
          Confirmation={this.state.confirmationDetail}
        />
        <div className={classes.containerRoot}>
        <div className={classes.containerTitle}>Continuation Confirmation Requests</div>
          <div className={classes.containerContent}>
            <Paper className={classes.containerPaper}>
              <NewTable
                enqueueSnackbar={this.props.enqueueSnackbar}
                loaded={this.state.initialLoadDone}
                loadedData={this.state.tableData}
                sortBy={this.state.sortBy}
                sortDirection={this.state.sortDirection}
                sortTable={this.sortTable}
                staticFilterValues={this.state.staticFilterValues}
                recordCount={this.state.recordCount}
                loadMoreRows={this.loadMoreRows}
                setActiveFilters={this.setActiveFilters}
                activeFilters={this.state.activeFilters}
                tableName={"Confirmation Requests"}
                columns={[
                  {
                    dataKey: "employer",
                    width: 300,
                    flexGrow: 4,
                    flexShrink: 1,
                    nestedCol: "name",
                    label: "Employer Name",
                    cellRenderer: nestedCellDataGetter,
                    customSort: nestedSort,
                    hasFilter: true,
                    filterType: "Search",
                  },
                  {
                    dataKey: "mewa",
                    nestedCol: "employer__mewa__name",
                    label: "MEWA",
                    customSort: nestedSort,
                    hasFilter: true,
                    hide: true, //dont neeed tis vis
                    filterType: "Static",
                  },
                  {
                    label: "Employer Contact",
                    dataKey: "employer_contact_email",
                    width: 300,
                    flexGrow: 4,
                    flexShrink: 1,
                    hasFilter: true,
                    filterType: "Search",
                  },
                  {
                    label: "Date Added",
                    dataKey: "date_added",
                    cellRenderer: dateCellDataGetter,
                    width: 125,
                    flexGrow: 0,
                    flexShrink: 0,
                    hasFilter: false,
                  },
                  {
                    label: "Date Closed",
                    dataKey: "date_closed",
                    cellRenderer: dateCellDataGetter,
                    width: 125,
                    flexGrow: 0,
                    flexShrink: 0,
                    hasFilter: false,
                  },
                  {
                    label: "Status",
                    dataKey: "status",
                    width: 150,
                    flexGrow: 0,
                    flexShrink: 0,
                    hasFilter: true,
                    filterType: "Static",
                  },
                ]}
                actionMenuItems={this.getActionMenuItems}
              />
            </Paper>
            <div id="tableStatus" style={{ display: "flex" }}>
              <div
                id="tableStatusIndicator"
                style={{
                  flexGrow: "1",
                  textAlign: "right",
                  marginRight: 0,
                  marginTop: 20,
                }}
                color="primary"
              >
                <TableStatusIndicator
                  initialCount={this.state.initialCount}
                  currentCount={this.state.currentCount}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ContactContainer);
